// Microsoft Clarity: grabaciones de sesión y heatmaps de toda la app.
//
// - ID de proyecto público (equivalente a un measurement ID de GA, no es secreto).
// - Se carga como script externo (no inline) porque la CSP de vercel.json no
//   permite 'unsafe-inline' en script-src; los dominios habilitados viven ahí
//   (www/scripts + *.clarity.ms + c.bing.com).
// - Guards compartidos en analyticsGuards.ts (ver shouldLoadTracker).
// - Clarity instrumenta la History API por su cuenta: los cambios de ruta de
//   React Router quedan registrados sin código extra. Sin grabación offline
//   (el SW no cachea scripts cross-origin, igual que el CDN de bootstrap-icons).

import { shouldLoadTracker } from './analyticsGuards';

const CLARITY_PROJECT_ID = 'yon31qygb6';

declare global {
  interface Window {
    clarity?: ((...args: unknown[]) => void) & { q?: unknown[][]; v?: unknown; t?: boolean };
  }
}

export function initClarity(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  if (!shouldLoadTracker(window.location.hostname, process.env.NODE_ENV === 'production', navigator.webdriver)) {
    return;
  }

  // El script /tag asume que la cola global window.clarity ya existe (la crea el
  // snippet oficial inline, que no podemos usar por la CSP). Mismo shim:
  window.clarity =
    window.clarity ||
    function (...args: unknown[]) {
      (window.clarity!.q = window.clarity!.q || []).push(args);
    };

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${CLARITY_PROJECT_ID}`;
  document.head.appendChild(script);
}
